// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73c6ee3a","239":"c3a10acf","732":"69519498"}[chunkId] + ".chunk.js";
};